import React, { useRef, useState } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { Select, DatePicker } from "antd";
import { Asterisk, currencyFormatter, zinedus3 } from "../../../utils/helperFunctions";
import ViewSlipModal from "../common/ViewSlipModal";
import moment from "moment";
import { toast } from "react-toastify";
import ToastMessage from "../../common/toastMessage";
import Api from "../../common/api";
import ApiUrl from "../../common/apiUrl";
import Swal from "sweetalert2";

const { Option } = Select;

const EMIDetails = (props) => {

    const {
        ackNo = "",
        loanID = "",
        entryDate = "",
        // chequeDate = "",
        bankName = "",
        studentID = "",
        studentName = "",
        studentMobile = "",
        centreName = "",
        amount = "",
        chequePhoto = "",
        id = "",
        updateEMI
    } = props;


    const chequeStatus = ["Paid", "Failed"];

    const [loading, setLoading] = useState(false);

    const [paymentReceiveDate, setPaymentReceiveDate] = useState("");
    
    const [paymentDeclineReason, setPaymentDeclineReason] = useState("");
    
    const [financeCharge, setFinanceCharge] = useState("");
    
    const [viewSlipModal, setViewSlipModal] = useState(false);

    const [selectedReason, setSelectedReason] = useState();

    const [errorText, setErrorText] = useState("");

    const errorTimeoutRef = useRef(null);

    const BootstrapTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: `${className} tooltip_header` }} />)(
        ({ theme }) => ({
            [`& .${tooltipClasses.arrow}`]: {
                color: theme.palette.common.black,
            },
            [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: theme.palette.common.black,
                fontSize: "13px",
            },
        })
    );

    const handleFinanceChargeChange = (e) => {
        const re = /^(\d+(\.\d{0,2})?|\.?\d{0,2})$/
        if (re.test(e.target.value)) {
        setFinanceCharge(e.target.value);
        }
    };

    const handleViewSlip = () => {
        setViewSlipModal((state) => !state);
    };

    const handleSubmitClick = async() => {

        if (loading) {
            return;
        }

        let payload = {
            status: selectedReason
        }

        if (selectedReason === "Paid") {
            payload.amount_receiving_date = moment(paymentReceiveDate).format("YYYY-MM-DD");
            payload.finance_charges = financeCharge
        } else if (selectedReason === "Failed") {
            payload.remarks = paymentDeclineReason;
        }

        setLoading(true);

        const data = await Api.doFetch("POST", payload, `${ApiUrl.UPDATE_PENDING_EMI}${id}`);

        setLoading(false);

        if(data?.status) {
            setSelectedReason("")
            setPaymentReceiveDate("")
            setPaymentDeclineReason("")
            setFinanceCharge("")
            updateEMI(id);
            toast(<ToastMessage text={"Payment updated successfully!"} />);
        } else {
            Swal.fire("Error!", data?.message || "Internal Server Error" , "error");
        }
    };

    return (
        <>
            <div className="pending-cheques__details_container">
                <div className="ack_number">Ack no. : {ackNo}</div>
                <div className="details_container_row1">
                    <div className="cheque-details__col-1">
                        <div className="cheque-details-col justify-content-between">
                            <div className="margin-right-det-col-cheque-first my-2">
                                <p className="cheque-details__label mb-0">Loan number</p>
                                <p className="cheque-details__label-1 mb-0">
                                    {loanID}{" "}
                                    <span className="view-cheque-link" onClick={handleViewSlip}>
                                        View slip
                                    </span>
                                </p>
                                {/* <p className="cheque-details__label-2 mb-0">Entry date: Jul 20, 2022</p> */}
                            </div>
                            <div className="margin-left-det-col-cheque-first my-2">
                                <p className="cheque-details__label mb-0">Finance company</p>
                                <p className="cheque-details__label-1 mb-0">{bankName|| "-"}</p>
                                <p className="cheque-details__label-2 mb-0">
                                    Entry date: {entryDate ? moment(entryDate).format("MMM DD, YYYY") : "-"}
                                </p>
                            </div>
                        </div>

                        <div className="student-details-col">
                            <div className="margin-right-det-col-cheque-first my-2">
                                <p className="cheque-details__label mb-0">Student ID</p>
                                <p className="cheque-details__label-1 mb-0">{studentID|| "-"}</p>
                                <p className="cheque-details__label-2 mb-0">
                                    Centre:{" "}
                                    {centreName && centreName.length >= 11 ? (
                                        <BootstrapTooltip disableFocusListener enterTouchDelay={0} title={centreName}>
                                            <span style={{ cursor: "pointer" }}>{centreName.substring(0, 11) + "..."}</span>
                                        </BootstrapTooltip>
                                    ) : (
                                        centreName || "-"
                                    )}
                                </p>
                            </div>
                            <div className="margin-left-det-col-cheque-first my-2">
                                <p className="cheque-details__label mb-0">Student name</p>
                                <p className="cheque-details__label-1 mb-0">{studentName|| "-"}</p>
                                <p className="cheque-details__label-2 mb-0">Phone number : {`${studentMobile ? `+91 ${studentMobile}` : "-"}`}</p>
                            </div>
                        </div>
                    </div>

                    <div className="cheque-details__col-2">₹ {currencyFormatter(amount, false)}</div>
                </div>

                <div className="details_container_row2">
                    <p className="update-cheque__heading mb-0">Update EMI</p>

                    <div className="cheque-form-container">
                        <div className="form-container__col-first">
                            <div className="cheque-status-select-container margin-right-det-col my-2 antd_dropdown">
                                <p className="cheque_filter_drop_header mb-1">
                                    Status <Asterisk />
                                </p>

                                <Select
                                    style={{ width: "100%" }}
                                    placeholder="Select status"
                                    showArrow
                                    allowClear
                                    optionFilterProp="children"
                                    value={selectedReason || undefined}
                                    onChange={(value) => {
                                        setSelectedReason(value);
                                    }}
                                >
                                    {chequeStatus.map((item, index) => {
                                        return (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>
                                {/* {chapterError.subject_assoc && <ErrorText text={chapterError.subject_assoc} />} */}
                            </div>

                            {selectedReason === "Failed" ? (
                                <div className="cheque-status-select-container margin-left-det-col my-2">
                                    <p className="cheque_filter_drop_header mb-1">
                                        Reason for failure <Asterisk />
                                    </p>
                                    <input
                                        className={`change_pw_input`}
                                        placeholder="Enter reason"
                                        value={paymentDeclineReason}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 300) {
                                                setPaymentDeclineReason(e.target.value);
                                                setErrorText("");
                                            } else {
                                                setErrorText("Max limit of 300 characters reached");
                                                if (errorTimeoutRef.current !== null && errorTimeoutRef.current <= 300) {
                                                    clearTimeout(errorTimeoutRef.current);
                                                }
                                                errorTimeoutRef.current = setTimeout(() => {
                                                    setErrorText("");
                                                }, 1200);
                                            }
                                        }}
                                    />
                                    {errorText && <p className="reject_reason_error">{errorText}</p>}
                                </div>
                            ) : (
                                <></>
                            )}

                            {selectedReason === "Paid" ? (
                                <>
                                    <div className="cheque-status-select-container margin-left-det-col my-2">
                                        <p className="cheque_filter_drop_header mb-1">
                                            Amount receiving date <Asterisk />
                                        </p>
                                        <DatePicker
                                            allowClear={false}
                                            className="attendance_date_picker mb-0"
                                            getPopupContainer={(triggerNode) => {
                                                return triggerNode.parentNode;
                                            }}
                                            placeholder="DD/MM/YYYY"
                                            // style={{ width: "100%" }}
                                            format={"DD/MM/YYYY"}
                                            onChange={(date) => setPaymentReceiveDate(date)}
                                            value={paymentReceiveDate}
                                        />
                                    </div>
                                    <div className="cheque-status-select-container margin-left-det-col my-2">
                                        <p className="cheque_filter_drop_header mb-1">
                                            Finance charge
                                            <Asterisk />
                                        </p>
                                        <input
                                            // type="number"
                                            // step="0.01"
                                            // min="0.01"
                                            className={`change_pw_input hidden_arrows_input_full_width`}
                                            placeholder="₹ 00.00"
                                            onChange={handleFinanceChargeChange}
                                            value={financeCharge}
                                        />
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                            {/* </div> */}
                        </div>

                        <div 
                            className="cheque-button-container"
                            style = {{ marginTop: "2.8rem" }}
                        >
                            <button
                                className="btn submit-btn-pending-cheque"
                                disabled={
                                    (selectedReason === "Paid" && paymentReceiveDate !== "" && financeCharge !== "") ||
                                    (selectedReason === "Failed" && paymentDeclineReason !== "")
                                        ? false
                                        : true
                                }
                                onClick={handleSubmitClick}
                            >
                                Submit
                                {loading && <span className="ml-2 spinner spinner-white mr-2"></span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ViewSlipModal
                handleViewSlip={handleViewSlip}
                name={studentName}
                date={entryDate}
                mobileNumber={studentMobile}
                ChequePhoto={chequePhoto ? `${zinedus3}${chequePhoto}` : ""}
                open={viewSlipModal}
                dataKey="loan"
                dataValue={loanID}
            />

        </>
    );
};

export default EMIDetails;
